export function elementExist(el) {
	return !!document.querySelector(el);
}
